import { Tooltip } from '@material-ui/core';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import { Flex, unselectable, Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { GridDropZone, GridItem } from 'react-grid-dnd';
import styled from 'styled-components';
import { DragBoxFlex, Title } from './CustomizeTableModal.sections';

const StyledCloseIcon = styled(Icon)`
  padding: 0.4rem;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: ${getColor('zircon')};
  }
`;

const StyledThreeDotsIcon = styled(Icon)`
  padding-left: 1rem;
`;

const StyledGridItem = styled(GridItem)`
  display: flex;
  align-items: center;
  padding-right: 1rem;
  justify-content: space-between;
  border-top: 1px solid ${getColor('catskillWhite')};
  border-right: 1px solid ${getColor('catskillWhite')};
  border-left: 1px solid ${getColor('catskillWhite')};
  ${({ islast }) =>
    islast ? `border-bottom: 1px solid ${getColor('catskillWhite')};` : ''};
  ${unselectable()};
  cursor: pointer;

  &:hover {
    box-shadow: 0px 0px 34px 0px #3b599833;
  }
`;

const ItemName = ({ name }) => (
  <Text align='left' pb='0.6rem' pl='1rem' pt='0.6rem' size='large'>
    {name}
  </Text>
);

const RightBox = ({ items = [], onRemove = () => null }) => {
  return (
    <DragBoxFlex pl='medium' direction='column'>
      <Title
        title={`${items.length} Selected columns`}
        subtitle='Remove, or drag to reorder'
      />
      <Padding b='small'></Padding>
      <GridDropZone
        id='right'
        boxesPerRow={1}
        rowHeight={40}
        style={{ height: 400 }}
        data-cy='rightMenu'
      >
        {items.map(({ name, id }, idx) => (
          <StyledGridItem islast={idx + 1 === items.length} key={id}>
            <Flex items='center'>
              <StyledThreeDotsIcon
                name='threedots'
                color='shuttleGray'
                size='medium'
              />
              <ItemName name={name} />
            </Flex>

            <Tooltip title='remove from table'>
              <StyledCloseIcon
                name='close'
                color='pigeonPost'
                size='small'
                onClick={() => onRemove(id)}
              />
            </Tooltip>
          </StyledGridItem>
        ))}
      </GridDropZone>
    </DragBoxFlex>
  );
};

export default RightBox;
